module.exports = 
    {   
        MWS_SUBD: 'mwsdbg',
        EDP_SUBD: 'edpdbg',
        DOMAIN: 'makrolog.de',
        OBJECT_PATH: 'edpmcm/mcm',
        GRECAPTCHA: 'on',
        SENTRY: 'off'
    }
